import * as React from 'react';

export const LanguageContext = React.createContext<'De' | 'En' | 'Us'>('De');
